export enum AnimalType {
    "Community Cat" = 1,
    "Chinchilla" = 2,
    "Community Dog" = 3,
    "Guinea Pig" = 4,
    "Pet Bird" = 5,
    "Pet Rabbit" = 6
}